import { connect } from "react-redux";
import { selectClient, getClientInfo } from "../../actions/App";
import { getClientSites } from "../../actions/Clients";
import {
  setReportWebSiteId,
  getFavoritePages,
  getInsightsMostPopularPages,
  saveFavoritePage,
} from "../../actions/Insights";
import InsightFavoritePagesIndex from "../../components/Insights/page/FavoritePages";

const mapStateToProps = state => {
  const {
    websiteId,
    favoritePages,
    mostPopularPages,
    loadingPopularPages,
    loadingFavoritePages,
    loadingFavoritePagesError,
  } = state.insights;
  const { client_sites } = state.clients;
  const { selected_client, clients, client_info, token } = state.app;
  return {
    websiteId,
    client_info,
    client_sites,
    selected_client,
    clients,
    location: state.routing.location,
    favoritePages,
    loadingFavoritePages,
    loadingFavoritePagesError,
    mostPopularPages,
    loadingPopularPages,
    token,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getClientInfo: cid => {
      dispatch(getClientInfo(cid));
    },

    getClientSites: cid => {
      dispatch(getClientSites(cid, true));
    },

    setWebsiteId: id => {
      dispatch(setReportWebSiteId(id));
    },

    selectClient: clientId => {
      dispatch(selectClient(clientId));
    },

    fetchFavoritePages: tagId => {
      dispatch(getFavoritePages(tagId));
    },

    fetchMostPopularPages: (tagId, dateRange) => {
      dispatch(getInsightsMostPopularPages(tagId, dateRange));
    },

    saveFavoritePage: (tagId, pages) => {
      dispatch(saveFavoritePage(tagId, pages));
    },
  };
};

const FavoritePagesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InsightFavoritePagesIndex);

export default FavoritePagesContainer;



// WEBPACK FOOTER //
// ./src/containers/Insights/FavoritePages.js